<script lang="ts">
import { hydrateRichExtras } from '$lib/render/hydrate';
import { renderRichText } from '$lib/render/richtext';

interface Props {
  /** Markdown-Quelle; darf inline-HTML-Spans (Cloze) enthalten. */
  content?: string | null;
}

const { content = '' }: Props = $props();
const html = $derived(renderRichText(content));
let el = $state<HTMLElement | null>(null);

$effect(() => {
  // html als Dependency: nach jedem Content-Wechsel neu hydrieren.
  void html;
  if (el) void hydrateRichExtras(el);
});
</script>

<div class="richtext" bind:this={el}>{@html html}</div>

<style>
  .richtext :global(p) { margin: 0 0 0.6em; }
  .richtext :global(p:last-child) { margin-bottom: 0; }
  .richtext :global(ul), .richtext :global(ol) { margin: 0.4em 0; padding-left: 1.4em; }
  .richtext :global(li) { margin: 0.15em 0; }
  .richtext :global(table) { border-collapse: collapse; margin: 0.5em 0; font-size: 0.92em; }
  .richtext :global(th), .richtext :global(td) { border: 1px solid var(--rule); padding: 3px 8px; text-align: left; }
  .richtext :global(th) { background: var(--paper-2); }
  .richtext :global(img) { max-width: 100%; height: auto; display: block; margin: 0.5em 0; border: 1px solid var(--rule); }
  .richtext :global(code) { font-family: var(--font-mono); font-size: 0.9em; background: var(--paper-2); padding: 0 4px; }
  .richtext :global(pre) { overflow-x: auto; background: var(--paper-2); padding: 8px; }
  .richtext :global(.rt-math[data-display='1']) { display: block; text-align: center; margin: 0.6em 0; overflow-x: auto; }
  .richtext :global(.rt-mermaid) { margin: 0.6em 0; overflow-x: auto; }
  .richtext :global(.rt-mermaid svg) { max-width: 100%; height: auto; }
  .richtext :global(.rt-fallback) { font-size: 0.85em; color: var(--muted); }
</style>
